import React from 'react';

const HybridSectionPage = ({ title }) => {
  return (
    <div className='text-left p-4 space-y-6'>
      <div className='max-w-4xl rounded-lg border border-slate-300 bg-white p-6 shadow-sm'>
        <h1 className='mb-4 text-3xl font-bold'>{title}</h1>
        <p className='text-lg leading-8'>
          Content for this section will go here.
        </p>
      </div>
    </div>
  );
};

export default HybridSectionPage;
